
<template>
  <div>
    <div class="container">
      <loading :active.sync="isLoading" :can-cancel="true"></loading>
      <div>
        <div class="banner-wrap">
          <div class="row align-items-center">
            <div class="col-md-7 text-left">
              <div class="banner-text">
                <h1>
                  <span style="font-size: 38px;">Safety Training</span>
                  <br />
                  <span style="font-size: 29px">for Building + Construction Workers</span>
                </h1>
                <p>
                  Building, construction and fit-out workers need to be trained to work safely.
                  <br />Achieve compliance with our great range of expert training options.
                </p>
                <span v-if="localTelNo">For further help, please call us on {{ localTelNo }}</span>
              </div>
            </div>

            <div class="col-md-5">
              <video width="95.5%" height="100%" controls preload="auto">
                <source
                  :src="image_url+'/videos/Construction_Safety_Training.mp4'"
                  type="video/mp4"
                />Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>

        <div class="row d-block d-md-none">
          <div class="col-12">
            <div class="citb">
              <img alt="citb-logo" :src="image_url+'/images/citb-logo.jpg'" />
              <p>
                The first step to your
                <br />
                <span>CSCS Green Labourer Card!</span>
              </p>
              <router-link
                :to="{name: 'course-detail', params:{id:'health-and-safety-awareness-for-construction-workers-day-training-course'}}"
              >More Info</router-link>
            </div>
          </div>
        </div>
        <hr class="d-block d-md-none" />

        <div class="dvd-section mb-15 bg-white">
          <div class="row">
            <div class="col-md-3 col-sm-3 text-center">
              <div class="dvd-box">
                <router-link
                  :to="{name: 'product-detail',params: {param1: 'dvds', param2:'construction-safety-awareness-dvd'}}"
                >
                  <div>
                    <img
                      alt="dvd-image-home"
                      :src="image_url+'/images/construction-safty-1.jpg'"
                      class="img-fluid"
                    />
                  </div>
                  <h2 class="link">Construction Safety DVD</h2>
                </router-link>
              </div>
            </div>

            <div class="col-md-3 col-sm-3 text-center">
              <div class="dvd-box">
                <router-link
                  :to="{name: 'product-detail',params: {param1: 'booklets-and-manuals', param2:'on-site-safety-booklets'}}"
                >
                  <div>
                    <img
                      alt="booklet-image-home"
                      :src="image_url+'/images/construction-safty-2.jpg'"
                      class="img-fluid"
                    />
                  </div>
                  <h2 class="link">Construction Safety Booklet</h2>
                </router-link>
              </div>
            </div>

            <div class="col-md-3 col-sm-3 text-center">
              <div class="dvd-box">
                <router-link
                  :to="{name: 'product-detail',params: {param1: 'booklets-and-manuals', param2:'construction-safety-manual'}}"
                >
                  <div>
                    <img
                      alt="manual-image-home"
                      :src="image_url+'/images/construction-safty-3.jpg'"
                      class="img-fluid"
                    />
                  </div>
                  <h2 class="link">Construction Safety Manual</h2>
                </router-link>
              </div>
            </div>

            <div class="col-md-3 col-sm-3 text-center">
              <div class="dvd-box">
                <router-link
                  :to="{name: 'product-detail',params: {param1: 'posters', param2:'construction-safety-posters-english'}}"
                >
                  <div>
                    <img
                      alt="poster-image-home"
                      :src="image_url+'/images/construction-safty-4.jpg'"
                      class="img-fluid"
                    />
                  </div>
                  <h2 class="link">Construction Poster</h2>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="company-section text-center pt-15 pb-5 bg-white d-none d-md-block">
          <p class="mb-25 p-md">
            <b>The Health and Safety Group memberships and approved centres:</b>
          </p>
          <ul class="members-info">
            <li>
              <div>
                <img :src="image_url+'/images/rospa.png'" alt="Member of The Royal Society for Prevention of Accidents" />
              </div>
              <p>Member of The Royal Society for Prevention of Accidents</p>
            </li>
            <li>
              <div>
                <img :src="image_url+'/images/cpd.png'" alt="Member of The CPD Standards Office" />
              </div>
              <p>Member of The CPD Standards Office</p>
            </li>
          </ul>
          <p class="mt-15 mb-15 p-md">
            <b>The Onsite Safety Training Company is a wholly owned subsidiary of</b>
          </p>
          <div class="text-center mb-15">
            <img alt="health&safety" :src="image_url+'/images/logo-md.jpg'" />
          </div>

          <div class="bodyBottom d-none d-md-block">
            <div class="bodyBottomHolder">
              <p>
                <span>Order online with confidence using our secure payment system.</span><br />
                <span v-if="localTelNo">Alternatively you can call us on {{ localTelNo }} to place your order.</span>
              </p>
              <ul>
                <li>
                  <a href="#">
                    <img alt="rbsWorld" :src="image_url+'/images/poweredByWorldPay.gif'" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img alt="paypal" :src="image_url+'/images/PayPal.gif'" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img alt="masterCard" :src="image_url+'/images/saterCard.png'" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img alt="maestroCard" :src="image_url+'/images/mastroCard.png'" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img alt="visaCard" :src="image_url+'/images/visaCard.png'" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img alt="amex" :src="image_url+'/images/amex_63x34.png'" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="bodyBottom d-block d-md-none">
          <div class="bodyBottomHolder">
            <p>
              <span>online with confidence using our secure payment system.</span><br />
              <span v-if="localTelNo">Alternatively you can call us on {{ localTelNo }} to place your order.</span>
            </p>
            <ul class>
              <li>
                <a href="#">
                  <img alt="rbsWorld-mobile" :src="image_url+'/images/l1.jpg'" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img alt="masterCard-mobile" :src="image_url+'/images/l2.jpg'" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img alt="maestroCard-mobile" :src="image_url+'/images/l3.jpg'" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img alt="visaCard-mobile" :src="image_url+'/images/l4.jpg'" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img alt="jcb-mobile" :src="image_url+'/images/l5.jpg'" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueMq from "vue-mq";
import Axios from "axios";
import Loading from "vue-loading-overlay";
import Swal from "sweetalert2";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Utils from "@/services/Utils";
import GenericMixin from "@/assets/mixins/GenericMixin";

Vue.use(VueMq, {
  breakpoints: {
    sm: 575,
    md: 1380,
    lg: Infinity
  }
});
export default {
  name: "home",
  data() {
    return {
      isLoading: false,
      image_url: process.env.VUE_APP_S3_IMAGE_URL,
      mobClass: "mob-bg",
      citbLink: process.env.VUE_APP_CITB_LINK,
      qualityMark: process.env.VUE_APP_QUALITY_MARK
    };
  },
  components: {
    Loading
  },
  mixins: [GenericMixin],
  methods: {
    popup(url, width = 800, height = 800) {
      Utils.popup(url, width, height);
    }
  },
  created() {},
  mounted() {
    if (
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) &&
      this.$route.name == "home"
    ) {
      $("#body").addClass("mob-bg");
      $("#nav").show();
    }
    $("#wrapper").click(function() {
      $("#nav-btn").show();
      document.getElementById("main-nav").style.width = "0";
      document.getElementById("wrapper").style.display = "none";
      document.getElementById("body").removeAttribute("style");
    });
    $("#mob-nav").click(function() {
      $("#nav-btn").hide();
      document.getElementById("main-nav").style.width = "300px";
      document.getElementById("wrapper").style.display = "block";
      document.getElementById("body").style.overflowX = "visible";
      document.getElementById("body").style.position = "fixed";
    });
  }
};
</script>

<style lang="scss" >
html,
body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  font-family: Arial, Helvetica, sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  background: #e6e6e6;
}

.mob-bg {
  background: #435885 url(../images/mob-bg.jpg);
  background-size: 100%;
  background-repeat: no-repeat;
  height: 100vh;
}
.banner-wrap {
  background: white;
  margin-bottom: 15px;
  .banner-text {
    padding: 15px;
    text-align: center;
    h1 {
      color: #1b3d82;
      margin-bottom: 15px;
      font-size: 32px;
      font-weight: bold;
    }
    p {
      font-size: 18px;
    }
    span {
      color: #1b3d82;
      font-weight: bold;
      font-size: 20px;
    }
  }
  video {
    float: left;
  }
}

.cus-pad {
  padding: 15px 20px;
  margin-bottom: 15px;
  text-align: left;
  h2 {
    font-size: 28px;
    color: #1b3d82;
    font-weight: bold;
    white-space: nowrap;
  }
  .flex {
    width: 85px;
  }
  ul {
    margin: 0;
    li {
      font-size: 18px;
    }
  }
  .more {
    color: #1b3d82;
    font-weight: bold;
    font-size: 24px;
    text-decoration: underline;
    bottom: 0;
  }
}
.dvd-box {
  h2.link {
    font-size: 18px;
  }
}
.dvd-section {
  border-top: 1px solid #e4e5e4;
  width: 100%;
  padding: 15px 20px 15px;
  margin-bottom: 15px;
  img {
    margin-bottom: 10px;
  }
  a.link {
    color: #1b3d82;
    font-size: 18px;
    font-weight: 700;
    margin: 0 auto;
  }
  .button-holder {
    margin-top: 10px;
  }
  .btn-cus {
    color: #000000;
    padding: 5px 40px;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    background: linear-gradient(135deg, #fac628 0%, #ffdf00 100%);
    border-radius: 10px;
    border: none;
  }
}
.company-section {
  margin-bottom: 15px;
  p {
    font-size: 18px;
    margin-bottom: 25px;
  }
  .members-info {
    margin: 15px 0 0;
    padding: 0;
    text-align: center;
    li {
      width: 200px;
      p {
        color: #2f2e2e;
        font-size: 15px;
        margin-top: 5px;
      }
    }
  }
}
.bodyBottom {
  margin-bottom: 5px;
  margin-top: 15px;
  text-align: center;
  width: 100%;
  border-top: 1px solid #e4e5e4;
  padding-top: 20px;
  p {
    color: #2f2e2e;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 15px;
  }
  ul {
    width: 100%;
    padding: 0;
    margin: 0;
    li {
      background: transparent none repeat scroll 0 0;
      display: inline-block;
      list-style: outside none none;
      margin: 3px;
      a {
        box-shadow: 2px 2px 7px -1px rgba(0, 0, 0, 0.3);
        display: block;
      }
    }
    li:first-child a {
      box-shadow: none;
    }
  }
}
.citb {
  width: 100%;
  padding: 15px;
  text-align: center;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  margin-top: 15px;
  margin-bottom: 16px;
  img {
    margin-bottom: 15px;
  }
  p {
    font-size: 22px;
    margin-bottom: 10px;
    span {
      font-weight: bold;
    }
  }
  a {
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    text-decoration: underline;
  }
}
hr {
  width: 100%;
  background: #ffffff;
}
@media (max-width: 575px) {
  .banner-wrap {
    display: inline-block;
    margin-bottom: 9px;
  }
  .banner-wrap .col-md-7 {
    display: none;
  }
  .dvd-section {
    //background-color: transparent !important;
    //padding: 12px 23px 0px;
    padding: 15px 22px 0px !important;
    margin-bottom: 0;
    .col-sm-3 {
      width: 50%;
      padding-right: 8px;
      padding-left: 8px;
    }
    img {
      border: 1px solid #8c8c89;
      max-width: 98%;
      margin-bottom: 6px !important;
    }
    .dvd-box {
      background: white;
      padding: 10px 12px;
      margin-bottom: 10px;
      .link {
        font-size: 14px;
        font-weight: bold;
        color: #1b3d82;
      }
      .btn-cus {
        padding: 5px 20px;
        font-size: 13px;
        border-radius: 4px;
      }
    }
  }
  .dvd-section .col-sm-3:nth-child(odd) {
    padding-right: 0px;
  }
  .dvd-section .col-sm-3:nth-child(even) {
    padding-left: 0px;
  }
  .bodyBottom {
    margin-bottom: 15px;
    p {
      color: white;
      font-weight: 400;
      font-size: 16px;
    }
    ul {
      li {
        margin: 2px;
        a img {
          width: 60px;
        }
      }
    }
  }
}
</style>